export default function Portfolio() {
  return (
    <div id="portfolio" className="our-portfolio section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div
              className="section-heading wow bounceIn"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
            >
              <h2>What to Expect</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 col-sm-6">
            <a href="#">
              <div
                className="item wow bounceInUp"
                data-wow-duration="1s"
                data-wow-delay="0.3s"
              >
                <div className="hidden-content">
                  <h4>Launch of ACTnet's sub-networks </h4>
                  <p>(Asia, Arctic, UrbanPort, etc.)</p>
                </div>
                <div className="showed-content">
                  {/* <img src="assets/images/portfolio-image.png" alt="" /> */}
                  <h4>Network In Motion</h4>
                </div>
              </div>
            </a>
          </div>
          <div className="col-lg-3 col-sm-6">
            <a href="#">
              <div
                className="item wow bounceInUp"
                data-wow-duration="1s"
                data-wow-delay="0.4s"
              >
                <div className="hidden-content">
                  <h4>Strategic alignment & long-term structure</h4>
                </div>
                <div className="showed-content">
                  {/* <img src="assets/images/portfolio-image.png" alt="" /> */}
                  <h3>Founder AGM</h3>
                </div>
              </div>
            </a>
          </div>
          <div className="col-lg-3 col-sm-6">
            <a href="#">
              <div
                className="item wow bounceInUp"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div className="hidden-content">
                  <h4>
                    Industry talks, collaborative dialogue, and idea exchange
                  </h4>
                </div>
                <div className="showed-content">
                  {/* <img src="assets/images/portfolio-image.png" alt="" /> */}
                  <h3>ACTnet Forum</h3>
                </div>
              </div>
            </a>
          </div>
          <div className="col-lg-3 col-sm-6">
            <a href="#">
              <div
                className="item wow bounceInUp"
                data-wow-duration="1s"
                data-wow-delay="0.6s"
              >
                <div className="hidden-content">
                  <h4>Shared vision setting & future roadmaps</h4>
                </div>
                <div className="showed-content">
                  {/* <img src="assets/images/portfolio-image.png" alt="" /> */}
                  <h3>Closing Plenary</h3>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
